import { useAtom } from '@reatom/npm-react'
import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { premiumConfigAtom } from '@root/entities/premium'
import { useTranslation } from '@root/shared/localization'

import { PremiumInfoHeader } from './premium-info-header'
import { PremiumInfoSection } from './premium-info-section'

import type { PremiumMeta } from '@root/entities/premium'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  product: PremiumMeta.PremiumProduct
} & ClassNameProps

export const PremiumInfo: React.FC<Props> = ({ product, className }) => {
  const { t } = useTranslation()
  const [{ premiumBoosters, extendPremiumBoosters }] =
    useAtom(premiumConfigAtom)
  const renderSubscriptionInfo = () => {
    return (
      <>
        <PremiumInfoSection
          title={t('premium.info.title.validity')}
          product={product}
        >
          {t('premium.info.text.validity', {
            extendBoosts: extendPremiumBoosters,
          })}
        </PremiumInfoSection>
        <PremiumInfoSection
          title={t('premium.info.title.what-it-gives')}
          product={product}
        >
          <Trans
            i18nKey="premium.info.text.what-it-gives"
            components={[<br key={0} />]}
          />
        </PremiumInfoSection>
        <PremiumInfoSection
          title={t('premium.info.title.how-to-buy')}
          product={product}
        >
          <Trans
            i18nKey="premium.info.text.how-to-buy"
            components={[<span key={0} />]}
          />
        </PremiumInfoSection>
        <PremiumInfoSection
          title={t('premium.info.title.requirements')}
          product={product}
        >
          {t('premium.info.text.requirements')}
        </PremiumInfoSection>
        <PremiumInfoSection
          title={t('premium.info.title.cost')}
          product={product}
        >
          {t('premium.info.text.cost', {
            boosts: premiumBoosters,
          })}
        </PremiumInfoSection>
      </>
    )
  }

  const renderContent = () => {
    if (product === 'subscription') {
      return (
        <>
          <PremiumInfoHeader
            title={
              <Trans
                i18nKey="premium.product.premium-title"
                components={[<span key={0} />]}
              />
            }
            subTitle={t('premium.info.sub-title')}
            product="subscription"
          />
          {renderSubscriptionInfo()}
        </>
      )
    }

    return (
      <>
        <PremiumInfoHeader
          title={
            <Trans
              i18nKey="premium.product.booster-title"
              components={[<span key={0} />]}
            />
          }
          subTitle={t('premium.info.sub-title')}
          product="boosters"
        />
        {/* TODO: Info for boosters */}
        {renderSubscriptionInfo()}
      </>
    )
  }

  return <Root className={className}>{renderContent()}</Root>
}

const Root = styled.div`
  display: grid;
`
